module.exports = __webpack_public_path__ + "static/media/fr.2f9befe9.svg";